<div class="container" [ngClass]="{ 'brand-container': fromBrandPage }" #container>
  <button *ngIf="shouldShowLeftArrow" class="arrow left" [attr.aria-label]="'FILTERS.FACETS.ARROW_LEFT.ARIA_LABEL' | translate" [ngClass]="{ 'brand-arrow-left': fromBrandPage }" (click)="prevClick()">
    <img class="filter__carousel-btn-icon"
         src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-left-bluegrey.svg" [alt]="'FILTERS.CATEGORIES_FACETS.ARROW_LEFT.ARIA_LABEL' | translate"/>
  </button>
  <button *ngIf="shouldShowRightArrow" class="arrow right" [attr.aria-label]="'FILTERS.FACETS.ARROW_RIGHT.ARIA_LABEL' | translate" [ngClass]="{ 'brand-arrow-right': fromBrandPage }" (click)="nextClick()">
    <img class="filter__carousel-btn-icon"
         src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-right-bluegrey.svg" [alt]="'FILTERS.CATEGORIES_FACETS.ARROW_RIGHT.ARIA_LABEL' | translate"/>
  </button>
  <div class="filter-facets__carousel" #carousel (scroll)="onScroll()">
    <div class="carousel__inner" #carouselInner>
      <ng-container *ngIf="isMobileOrTablet; else isDesktop">
        <div *ngIf="(isTagsVisible || isBlackDealsTagVisible)" class="facet clear-facet" (click)="clearTags()">
          <span class="facet__text bold">{{'FILTERS.FILTER_TAGS.CLEAR_ALL_TAG.TEXT' | translate}}</span>
        </div>
        <div *ngIf="(blackDeal$ | async)?.totalCount && isBlackDealsEnabled" class="facet"
             [ngClass]="{ 'selected': (blackDealTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: blackDealTag$ | async}" (click)="onBlackDealFilterFacetClick()">
            {{ 'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate }}
          </span>
          <button *ngIf="blackDealTag$ | async" (click)="removeBlackDealTag(blackDealTag)" class="facet__clear-btn" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate
          }">
            <mm-icon class="facet__clear-icon"
                     name="close_grey">
            </mm-icon>
          </button>

        </div>
        <div *ngIf="(promotion$ | async)?.totalCount" class="facet"
             [ngClass]="{ 'selected': (promotionTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: promotionTag$ | async}" (click)="onPromotionFilterFacetClick()">
            {{ 'FILTERS.FILTER_TAGS.PROMTION_TAG.ON_SALE' | translate }}
          </span>
          <button *ngIf="promotionTag$ | async" class="facet__clear-btn" (click)="removePromotionTag(volumePriceTag)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'FILTERS.FILTER_TAGS.PROMTION_TAG.ON_SALE' | translate
          }">
            <mm-icon class="facet__clear-icon"
                     name="close_grey">
            </mm-icon>
          </button>

        </div>
        <div *ngIf="(volumePrice$ | async)?.totalCount" class="facet"
             [ngClass]="{ 'selected': (volumePriceTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: volumePriceTag$ | async}"
                (click)="onVolumePriceFilterFacetClick()">
            {{ 'FILTERS.FILTER_TAGS.VOLUME_PRICE' | translate }}
          </span>
          <button *ngIf="volumePriceTag$ | async" class="facet__clear-btn" (click)="removeVolumePriceTag(promotionTag)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'FILTERS.FILTER_TAGS.VOLUME_PRICE' | translate
          }">
            <mm-icon class="facet__clear-icon"
                     name="close_grey">
            </mm-icon>
          </button>

        </div>
        <div *ngIf="(rebuyGuarantee$ | async) as rebuyGuarantee" class="facet"
             [ngClass]="{ 'selected': (rebuyGuaranteeTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: rebuyGuaranteeTag$ | async}"
                (click)="onRebuyGuaranteeFilterFacetClick(rebuyGuarantee?.id)">
            {{ rebuyGuarantee?.name}}
          </span>
          <button *ngIf="rebuyGuaranteeTag$ | async" class="facet__clear-btn" (click)="removeRebuyGuaranteeTag(rebuyGuarantee)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: rebuyGuarantee?.name
          }">
            <mm-icon  class="facet__clear-icon"
                      name="close_grey">
            </mm-icon>
          </button>
        </div>
        <div *ngIf="priceRange$ | async">
          <div class="facet" [ngClass]="{ 'selected': (priceFilterTag$ | async) }"
               (click)="onPriceFilterFacetClick()">
          <span *ngIf="!(priceFilterTag$ | async)" class="facet__text">{{
            'CATALOG.CATALOG_PAGE.FILTERS.TITLE.PRICE' | translate
            }}</span>
            <ng-container *ngIf="priceFilterTag$ | async as price">
              <span *ngIf="price.from && price.to" class="facet__text bold">
                {{ 'FILTERS.FILTER_TAGS.PRICE_RANGE_TAG.TEXT' | translate: {
                min: price.from | number,
                max: price.to | number
              }
                }}
              </span>
              <button class="facet__clear-btn"  (click)="removePriceTag($event)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.PRICE' | translate
          }">
                <mm-icon class="facet__clear-icon" name="close_grey"></mm-icon>
              </button>

            </ng-container>
          </div>
        </div>
        <div *ngIf="(categoriesTags$ | async)?.length" class="facet selected"
             (click)="onCategoryFilterFacetClick()">
          <span class="facet__text">{{'CATALOG.CATALOG_PAGE.FILTERS.TITLE.CATEGORY' | translate}}</span>
          <span class="padding-right-xs">:</span>
          <span *ngFor="let selectedCategories of (categoriesTags$ | async); let last=last"
                class="facet__text bold">
            {{ selectedCategories?.value?.name }}<span *ngIf="!last">,</span>
          </span>
          <button class="facet__clear-btn" (click)="removeCategoryTag()" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.CATEGORY' | translate
          }">
            <mm-icon class="facet__clear-icon" name="close_grey"></mm-icon>
          </button>
        </div>
        <ng-container *ngFor="let attribute of attributes$ | async">
          <div *ngIf="!(attribute?.options?.length === 1 && attribute?.options[0]?.value === 'int_rbg')"
               class="facet"
               [ngClass]="{ 'selected': isFilterValueExists(attribute) }"
               (click)="onAttributeFilterFacetClick(attribute)">
            <span class="facet__text">{{ attribute.name }}</span>
            <ng-container *ngFor="let selectedAttr of modifiedSelectedFilterData">
              <ng-container *ngIf="selectedAttr?.id === attribute.id && selectedAttr?.options?.length">
                <span class="padding-right-xs">:</span>
                <span class="facet__text bold">
              {{ selectedAttr?.options.join(', ') }}
            </span>
              </ng-container>
              <ng-container *ngIf="selectedAttr?.id === attribute.id && selectedAttr?.optionsRange">
                <span class="padding-right-xs">:</span>
                <span *ngIf="selectedAttr.optionsRange?.from && selectedAttr.optionsRange?.to"
                      class="facet__text">
                {{selectedAttr.optionsRange?.from}} {{'FILTERS.FILTER_TAGS.FILTER_RANGE.UNIT.CM'  | translate}} -
                  {{selectedAttr.optionsRange?.to}} {{'FILTERS.FILTER_TAGS.FILTER_RANGE.UNIT.CM'  | translate}}
              </span>
              </ng-container>
            </ng-container>
            <button *ngIf="isFilterValueExists(attribute)" class="facet__clear-btn" (click)="removeAttributeTag(attribute, $event)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: attribute?.name
          }">
              <mm-icon  class="facet__clear-icon" name="close_grey">
              </mm-icon>
            </button>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #isDesktop>
        <div *ngIf="(isTagsVisible|| isBlackDealsTagVisible)" class="facet clear-facet" (click)="clearTags()">
          <span class="facet__text bold">{{'FILTERS.FILTER_TAGS.CLEAR_ALL_TAG.TEXT' | translate}}</span>
        </div>
        <div *ngIf="(blackDealTag$ | async) && isBlackDealsEnabled" class="facet" [ngClass]="{ 'selected': (blackDealTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: blackDealTag$ | async}" (click)="onBlackDealFilterFacetClick()">
            {{ 'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate }}
          </span>
          <button *ngIf="blackDealTag$ | async" class="facet__clear-btn" (click)="removeBlackDealTag(blackDealTag)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate
          }">
            <mm-icon  class="facet__clear-icon"
                      name="close_grey">
            </mm-icon>
          </button>
        </div>
        <div *ngIf="promotionTag$ | async" class="facet" [ngClass]="{ 'selected': (promotionTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: promotionTag$ | async}" (click)="onPromotionFilterFacetClick()">
            {{ 'FILTERS.FILTER_TAGS.PROMTION_TAG.ON_SALE' | translate }}
          </span>
          <button *ngIf="promotionTag$ | async"  class="facet__clear-btn" (click)="removePromotionTag(volumePriceTag)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'FILTERS.FILTER_TAGS.PROMTION_TAG.ON_SALE' | translate
          }">
            <mm-icon  class="facet__clear-icon"
                      name="close_grey">
            </mm-icon>
          </button>
        </div>
        <div *ngIf="volumePriceTag$ | async" class="facet"
             [ngClass]="{ 'selected': (volumePriceTag$ | async) }">
          <span class="facet__text" [ngClass]="{ bold: volumePriceTag$ | async}"
                (click)="onVolumePriceFilterFacetClick()">
            {{ 'FILTERS.FILTER_TAGS.VOLUME_PRICE' | translate }}
          </span>
          <button *ngIf="volumePriceTag$ | async" class="facet__clear-btn" (click)="removeVolumePriceTag(promotionTag)"  [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'FILTERS.FILTER_TAGS.VOLUME_PRICE' | translate
          }">
            <mm-icon class="facet__clear-icon"
                     name="close_grey">
            </mm-icon>
          </button>
        </div>
        <div *ngIf="(rebuyGuaranteeTag$ | async) && rebuyGuarantee" class="facet selected">
          <span class="facet__text bold"
                (click)="onRebuyGuaranteeFilterFacetClick(rebuyGuarantee?.id)">
            {{ rebuyGuarantee?.name}}
          </span>
          <button class="facet__clear-btn" (click)="removeRebuyGuaranteeTag(rebuyGuarantee)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: rebuyGuarantee?.name
          }">
            <mm-icon class="facet__clear-icon"
                     name="close_grey"
            >
            </mm-icon>
          </button>
        </div>
        <div *ngIf="priceFilterTag$ | async as price">
          <div class="facet selected" (click)="onPriceFilterFacetClick()">
            <span *ngIf="price.from && price.to" class="facet__text bold">
                {{ 'FILTERS.FILTER_TAGS.PRICE_RANGE_TAG.TEXT' | translate: {
              min: price.from | number,
              max: price.to | number
            }
              }}
              </span>
            <button class="facet__clear-btn" (click)="removePriceTag($event)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.PRICE' | translate
          }">
              <mm-icon class="facet__clear-icon" name="close_grey"></mm-icon>
            </button>

          </div>
        </div>
        <div *ngIf="(categoriesTags$ | async)?.length" class="facet selected"
             (click)="onCategoryFilterFacetClick()">
          <span class="facet__text">{{'CATALOG.CATALOG_PAGE.FILTERS.TITLE.CATEGORY' | translate}}</span>
          <span class="padding-right-xs">:</span>
          <span *ngFor="let selectedCategories of (categoriesTags$ | async); let last=last"
                class="facet__text bold">
            {{ selectedCategories?.value?.name }}<span *ngIf="!last">,</span>
          </span>
          <button class="facet__clear-btn" (click)="removeCategoryTag()" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.CATEGORY' | translate
          }">
            <mm-icon class="facet__clear-icon" name="close_grey"></mm-icon>
          </button>
        </div>
        <div *ngFor="let selectedAttr of modifiedSelectedFilterData">
          <div class="facet" [ngClass]="{ selected: isFilterValueExists(selectedAttr) }">
            <span class="facet__text">{{ selectedAttr.name }}</span>
            <ng-container *ngIf="selectedAttr?.id === selectedAttr.id && selectedAttr?.options?.length">
              <span class="padding-right-xs">:</span>
              <span class="facet__text bold"> {{ selectedAttr?.options.join(', ') }} </span>
            </ng-container>
            <ng-container *ngIf="selectedAttr?.optionsRange">
              <span class="padding-right-xs">:</span>
              <ng-template [ngIf]="selectedAttr.optionsRange?.from && selectedAttr.optionsRange?.to">
                {{selectedAttr.optionsRange?.from}} {{'FILTERS.FILTER_TAGS.FILTER_RANGE.UNIT.CM'  | translate}}
                -
                {{selectedAttr.optionsRange?.to}} {{'FILTERS.FILTER_TAGS.FILTER_RANGE.UNIT.CM'  | translate}}
              </ng-template>
            </ng-container>
            <button *ngIf="isFilterValueExists(selectedAttr)" class="facet__clear-btn" (click)="removeAttributeTag(selectedAttr, $event)" [attr.aria-label]="'FILTERS.FILTER_TAGS.CLEAR_TAG.ARIA_LABEL' | translate: {
          filter_name: selectedAttr?.name
          }">
              <mm-icon class="facet__clear-icon" name="close_grey">
              </mm-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
